import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'myusers',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'myUserList',
      component: () => import('@/views/myusers/index.vue'),
      meta: {
        roles: ['company'],
      },
    },
    {
      path: ':userId/transactions',
      name: 'myUserTransaction',
      component: () => import('@/views/myusers/transactions/index.vue'),
      meta: {
        roles: ['company'],
      },
    },
    {
      path: ':userId/transactions/:transactionId/metadata',
      name: 'myUserTransactionMetadata',
      component: () => import('@/views/myusers/transactions/metadata/index.vue'),
      meta: {
        roles: ['withoutrules', 'company'],
      },
    },
    {
      path: ':userId/transactions/:transactionId/metadata/:metadataId/data',
      name: 'myUserTransactionMetadataData',
      component: () => import('@/views/myusers/transactions/metadata/data/index.vue'),
      meta: {
        roles: ['withoutrules', 'company'],
      },
    },
  ],
});
